import { render, staticRenderFns } from "./landing-page.vue?vue&type=template&id=ba3f8534&scoped=true"
import script from "./landing-page.vue?vue&type=script&lang=js"
export * from "./landing-page.vue?vue&type=script&lang=js"
import style0 from "./landing-page.vue?vue&type=style&index=0&id=ba3f8534&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba3f8534",
  null
  
)

export default component.exports